import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowUpwardAltProps = IconComponentBaseProps;

export const ArrowUpwardAlt = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.red[6],
}: ArrowUpwardAltProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4130_26532"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect x="0.5" y="0.5" width="16" height="16" fill={fill} />
      </mask>
      <g mask="url(#mask0_4130_26532)">
        <path
          d="M7.99985 5.90519L5.78451 8.12053C5.69218 8.21286 5.57612 8.26008 5.43634 8.26219C5.29668 8.26431 5.17851 8.21708 5.08185 8.12053C4.98529 8.02397 4.93701 7.90686 4.93701 7.76919C4.93701 7.63164 4.98529 7.51458 5.08185 7.41803L8.07801 4.42186C8.19857 4.30131 8.33918 4.24103 8.49985 4.24103C8.66051 4.24103 8.80112 4.30131 8.92168 4.42186L11.9178 7.41803C12.0101 7.51025 12.0573 7.62625 12.0595 7.76603C12.0616 7.90581 12.0144 8.02397 11.9178 8.12053C11.8212 8.21708 11.7041 8.26536 11.5665 8.26536C11.429 8.26536 11.3118 8.21708 11.2152 8.12053L8.99985 5.90519V11.7692C8.99985 11.9111 8.95196 12.0299 8.85618 12.1257C8.76051 12.2214 8.64173 12.2692 8.49985 12.2692C8.35796 12.2692 8.23918 12.2214 8.14351 12.1257C8.04773 12.0299 7.99985 11.9111 7.99985 11.7692V5.90519Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
